import React from 'react';
import History from '../../util/history';
import { trackPage } from '../../util/analytics';
import { isWeb } from '../../util/env';

export default function withTracker(WrappedComponent, options = {}) {

    const HOC = class Hoc extends React.Component {

        componentDidMount() {
            if(!isWeb()) {
                trackPage(History.location.pathname, options);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return HOC;
}